const fileExtRegex = /(?:\.([^.]+))?$/;
export const getExtensionFromFileName = (fileName: string) => {
  const result = fileExtRegex.exec(fileName);
  if (result && result[1]) {
    return `.${result[1]}`;
  }
  return 'unknown';
};
